import React from 'react';
import { Quote, Star } from 'lucide-react';
import { testimonials } from '../data/mock';

const additionalTestimonials = [
  {
    quote: 'The 7 Pillars of Wisdom teaching transformed how I approach decisions in my business. Biblical principles that actually work.',
    author: 'David R.',
    role: 'Business Owner'
  },
  {
    quote: 'Through the meditation resources, I finally learned to quiet my mind and hear God clearly. Life-changing.',
    author: 'Maria L.',
    role: 'Healthcare Professional'
  },
  {
    quote: 'The community here welcomed me when I was just curious about faith. No pressure, just genuine love and answers.',
    author: 'Tom H.',
    role: 'Former Agnostic'
  }
];

const allTestimonials = [...testimonials, ...additionalTestimonials];

const Testimonials = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1 bg-amber-50 text-amber-600 rounded-full text-sm font-medium mb-4">
            Stories of Transformation
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Lives changed through
            <span className="bg-gradient-to-r from-amber-600 to-orange-600 bg-clip-text text-transparent"> faith</span>
          </h2>
          <p className="text-lg text-slate-600">
            Hear from people whose lives have been transformed through the resources and community at 3strand Cord.
          </p>
        </div>

        {/* Testimonials grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {allTestimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`group p-6 bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 ${
                index === 1 ? 'md:translate-y-4' : ''
              }`}
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              
              <Quote className="w-8 h-8 text-slate-200 mb-3" />
              
              <p className="text-slate-700 leading-relaxed mb-6">
                &ldquo;{testimonial.quote}&rdquo;
              </p>
              
              <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-semibold text-sm">
                  {testimonial.author.charAt(0)}
                </div>
                <div>
                  <p className="font-medium text-slate-900">{testimonial.author}</p>
                  <p className="text-sm text-slate-500">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            { value: '10,000+', label: 'Lives Transformed' },
            { value: '50+', label: 'Countries Reached' },
            { value: '500+', label: 'Resources Available' },
            { value: '24/7', label: 'Prayer Support' }
          ].map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
                {stat.value}
              </div>
              <div className="text-sm text-slate-600 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
